import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function C() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('powerstreamcooperation');
    const { locale } = useRouter();

    return (
        <div className={`powerstream-cooperation-C ${css['powerstream-cooperation-C']}`}>
            <p className="title">{t('secC_title')}</p>
            <p className="desc">{t('secC_desc')}</p>
            <div className="img-wrapper">
                <div className="img img-1">
                    <EFPicture
                        src="/responsive/picture/powerstream-cooperation/3_1_1366.jpg"
                        srcMobile="/responsive/picture/powerstream-cooperation/3_1_375.jpg"
                        alt={t('secC_title')}
                    />
                    <p className="text">{t('secC_text1')}</p>
                </div>
                <div className="img img-2">
                    <EFPicture
                        src="/responsive/picture/powerstream-cooperation/3_2_1366.jpg"
                        srcMobile="/responsive/picture/powerstream-cooperation/3_2_375.jpg"
                        alt={t('secC_title')}
                    />
                    <p className="text">{t('secC_text2')}</p>
                </div>
                {locale === 'it' && (
                    <>
                        <div className="img img-3">
                            <EFPicture
                                src="/responsive/picture/powerstream-cooperation/3_qe_1366.jpg"
                                srcMobile="/responsive/picture/powerstream-cooperation/3_qe_375.jpg"
                                alt={t('secC_title')}
                            />
                            <p className="text">{t('secC_text3')}</p>
                        </div>
                        <div className="img img-4">
                            <EFPicture
                                src="/responsive/picture/powerstream-cooperation/3_3_1366.jpg"
                                srcMobile="/responsive/picture/powerstream-cooperation/3_3_375.jpg"
                                alt={t('secC_title')}
                            />
                            <p className="text">{t('secC_text4')}</p>
                        </div>
                    </>
                )}
                {['es', 'fr'].includes(locale) && (
                    <>
                        <div className="img img-3">
                            <EFPicture
                                src="/responsive/picture/powerstream-cooperation/3_3_1366.jpg"
                                srcMobile="/responsive/picture/powerstream-cooperation/3_3_375.jpg"
                                alt={t('secC_title')}
                            />
                            <p className="text">{t('secC_text3')}</p>
                        </div>
                        <div className="img img-4">
                            <EFPicture
                                src="/responsive/picture/powerstream-cooperation/3_4_1366.jpg"
                                srcMobile="/responsive/picture/powerstream-cooperation/3_4_375.jpg"
                                alt={t('secC_title')}
                            />
                            <p className="text">{t('secC_text4')}</p>
                        </div>
                        <div className="img img-5">
                            <EFPicture
                                src="/responsive/picture/powerstream-cooperation/3_qe_1366.jpg"
                                srcMobile="/responsive/picture/powerstream-cooperation/3_qe_375.jpg"
                                alt={t('secC_title')}
                            />
                            <p className="text">{t('secC_text5')}</p>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
